module.exports = __webpack_public_path__ + "img/recommendIcon.772fcc5c.gif";